<template>
	<div class="passwordetail">
		<div class="passwordetail_title">
			<p>修改手机号</p>
		</div>
		<div style="width:36%;margin-left: 28%;padding-top: 50px;">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="身份证号" prop="idCard">
					<el-input v-model="ruleForm.idCard"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone">
					<el-input v-model="ruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item label="验证码" prop="phoneCode">
					<el-input v-model="ruleForm.phoneCode"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button class="register_btn" @click="submitForm('ruleForm')">确定</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import {
		vaildate
	} from '../../utils/validate.js'
	export default {
		data() {
			const isCardId = (rule, value, callback) => {
				if (!value) {
					return new Error("请输入身份证号")
				} else {
					if (rule.field == 'idCard') {
						if (!vaildate.isIdCard(value)) {
							callback(new Error("身份证号格式有误"))
						} else {
							callback()
						}
					}
				}
			}
			return {
				ruleForm: {
					idCard: '',
					password: '',
					surePassword: '',
					phone: '',
					phoneCode: '',
					resource: '',
				},
				rules: {
					idCard: [{
							required: true,
							message: '请输入身份证号码',
							trigger: 'blur'
						},
						{
							validator: isCardId,
							trigger: 'blur'
						}
					],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					surePassword: [{
						required: true,
						message: '请输入确认密码',
						trigger: 'blur'
					}],
					phone: [{
						type: 'number',
						required: true,
						message: '请输入手机号码',
						trigger: 'change'
					}],
					phoneCode: [{
						required: true,
						message: '请输入手机验证码',
						trigger: 'change'
					}],
				}
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<style scoped>
	>>>.el-input__inner{
		width: 300px;
	}
	.register_btn {
		width: 300px;
		background-color: #c22c25;
		color: #fff;
	}
	.passwordetail {
		height: 650px;
		background-color: #fff;
	}

	.passwordetail_title {
		height: 60px;
		font-weight: 500;
		font-size: 22px;
		line-height: 60px;
		padding-left: 20px;
		border-bottom: 1px solid #f2f2f2;
	}
</style>
